import env from "@/configuration/env";

export default function registerEnv(app) {
  app.config.globalProperties.$env = env;
}
